
import { Base } from '../base-component';
import Slider from '../slider/slider.component';
import { MediaQueryService } from '../../services/media-query.service';

import './profile-list.component.scss';

export class ProfileList extends Base {

	sliderContainer: Element;
	sliderPagination: Element;
	sliderConfig: SwiperOptions;
	sliderNext: Element;
	sliderPrev: Element;
	windowWidth: number;
	sliderItems: number;
	breakpoints: {};
	tabsDesktopSelector: any;
	tabsContainers: any;
	tabsSelect: any;

	// video player
	playButton: any;
	closeButton: any;
	playerContainer: any;
	playerContent: any;
	playerTimeContainer: any;
	isExternal: boolean;
	time: any;
	player: any;
	video: any;


	constructor(element: Element){
		
		super(element);
				
	}
		
	init(){		

		if(Number(this.element.getAttribute('data-items'))) {
			this.sliderItems = Number(this.element.getAttribute('data-items'));
		}else{
			this.sliderItems = 3;
		}
		this.sliderContainer = this.element.querySelector('.swiper-container');
		this.sliderPagination = this.element.querySelector('.swiper-pagination');
		this.sliderNext = this.element.querySelector('.swiper-button-next');
		this.sliderPrev = this.element.querySelector('.swiper-button-prev');
		this.windowWidth = document.documentElement.clientWidth;

		this.tabsDesktopSelector = Array.from(this.element.querySelectorAll('.js-tab-trigger'));
		this.tabsContainers = Array.from(this.element.querySelectorAll('.tabs__item-content'));
		this.tabsSelect = this.element.querySelector('.js-option-selector');

		if(this.element.classList.contains('js-profile-carousel')){
			this.breakpoints = {
				992: {
					initialSlide: 0,
					slidesPerView: 2,
					spaceBetween: 20,
				},
				576: {
					initialSlide: 0,
					slidesPerView: 1.1,
					spaceBetween: 15,
				}
			};
		}else{
			switch (this.sliderItems) {
				case 1:
					this.breakpoints = {};
					break;
				case 2:
					this.breakpoints = {
						576: {
							initialSlide: 0,
							slidesPerView: 1.3,
							spaceBetween: 15,
						}
					};
					break;
				default:
					this.breakpoints = {
						1200: {
							initialSlide: 0,
							slidesPerView: 2.1,
							spaceBetween: 30,
						},
						768: {
							initialSlide: 0,
							slidesPerView: 2.1,
							spaceBetween: 20,
						},
						576: {
							initialSlide: 0,
							slidesPerView: 1.1,
							spaceBetween: 15,
						}
					};
					break;
			}
		}

		this.sliderConfig = {
			slidesPerView: this.sliderItems,
			spaceBetween: 30,
			initialSlide: 0,
			breakpoints: this.breakpoints,
			pagination: {
				el: this.sliderPagination,
				type: 'bullets',
				clickable: true
			},
			navigation: {
				nextEl: this.sliderNext,
				prevEl: this.sliderPrev,
			}
		};

		Slider.init(this.sliderContainer, this.sliderConfig);
		this.removeHeightsAuto();

	}
		
	bindEvents() {

		if(this.tabsSelect) {
			this.tabsSelect.addEventListener('change', (event)=>{ 
				let element = event.target;
				let index = element.selectedIndex;
				let value = element.value;
				this.showTabContentMobile(index);
			})
		}

		if(this.tabsDesktopSelector) {
			this.tabsDesktopSelector.map((item) => item.addEventListener('click', (event)=>{
				let element;
				if(event.currentTarget) {
					element = event.currentTarget;
				}else{
					element = event.target;
				}
				let id = element.getAttribute('data-target');
				this.showTabContentDesktop(id);
			}));
		}

		$(this.element).on('click', '.js-video-play', (event) => {
			this.showVideo(event);
		});

		$(this.element).on('click', '.js-video-close', (event) => {
			this.hideVideo(event);
		});

	}

	removeHeightsAuto() {
		let index = 0;
		this.tabsContainers.map((container)=>{
			if(index !== 0){
				container.classList.add('profile-list__tabs-container--hidden');
			}
			index++;
		})
	}

	showTabContentMobile(indexSelected) {
		let index = 0;
		this.tabsContainers.map((container)=>{
			container.classList.add('profile-list__tabs-container--hidden');
			container.classList.remove('tabs__item-content--active');
			if(index === indexSelected) {
				container.classList.add('tabs__item-content--active');
				container.classList.remove('profile-list__tabs-container--hidden');
			}
			index++;
		})
	}

	showTabContentDesktop(id) {
		this.tabsContainers.map((container)=>{	
			container.classList.add('profile-list__tabs-container--hidden');
			container.classList.remove('tabs__item-content--active');
			if(container.id === id) {
				container.classList.add('tabs__item-content--active');
				container.classList.remove('profile-list__tabs-container--hidden');
			}
		})
	}


	showVideo(event) {

		let element: any = event.target;

		if(this.element.classList.contains('profile-list-filter')){

			this.hideActiveVideo(element);

			if(element.hasAttribute('data-youtube-id')){
	
				this.playerContainer = element.closest('.video-carousel-item__container');
				this.playerContent = this.playerContainer.querySelector('.video-carousel-item__playercontent');
				this.playerContainer.classList.add('video-carousel-item__container--playing');
	
				this.isExternal = true;
				let getYoutubeId = element.getAttribute('data-youtube-id');
				this.createIframePlayer(getYoutubeId);
	
			}else if(element.hasAttribute('data-vidavee-id')) {
	
				this.playerContainer = element.closest('.video-carousel-item__container');
				this.playerContent = this.playerContainer.querySelector('.video-carousel-item__playercontent');
				this.playerContainer.classList.add('video-carousel-item__container--playing');
	
				this.isExternal = true;
				let getVidaveeId = element.getAttribute('data-vidavee-id');
				this.createIframePlayer(getVidaveeId, true);
	
			}

		}

	}

	hideVideo(event) {

		let removeIframe = this.playerContent.querySelector('iframe');

		this.playerContainer.classList.remove('video-carousel-item__container--playing');

		if(removeIframe){

			this.playerContent.removeChild(removeIframe); 

		}

	}

	hideActiveVideo(element){
		
		let selectedVideo = element.closest('.video-carousel-item__container');

		if(!selectedVideo.classList.contains('video-carousel-item__container--playing')){

			let videoContainers: any = Array.from(document.querySelectorAll('.video-carousel-item__container--playing'));

			videoContainers.map((itemContainer) => {
				itemContainer.classList.remove('video-carousel-item__container--playing');
				let iframeExistence: any = itemContainer.querySelector('iframe');
				if(iframeExistence){
					let iframeChildren = $(itemContainer).find('iframe');
					iframeChildren.remove();
				}else{
					let videoChildren: any = itemContainer.querySelector('video');
					let playerChildren: any = itemContainer.querySelector('.ot-video-containingBlock');
					videoChildren.pause();
				}
			});
						
		}

	}

	createIframePlayer(url: any, vidavee: any = false){

		if(vidavee) {
			
			let externalUrl = '/vidaveePlayer.jsp?remoteId=';
			externalUrl += url;
			let createIframe = document.createElement('iframe');
			createIframe.id = 'video__external';
			createIframe.src = externalUrl;
			createIframe.classList.add('video__iframe');
			this.playerContent.appendChild(createIframe);

		}else{

			let externalUrl = 'https://www.youtube.com/embed/';
			externalUrl += url;
			externalUrl += '?rel=0&amp;showinfo=0&autoplay=1&enablejsapi=1';
			let createIframe = document.createElement('iframe');
			createIframe.id = 'video__external';
			createIframe.src = externalUrl;
			createIframe.classList.add('video__iframe');
			this.playerContent.appendChild(createIframe);

		}

	}

}



// WEBPACK FOOTER //
// ./components/profile-list/profile-list.component.ts